import { ProductDto } from '@eurogast/hub-client-typescript';
import { ConfigService } from '@/services/ConfigService';

export abstract class LinkUtil {
  /**
   * Gets a string that's suitable for usage in links.
   * @param str The string to make link-friendly
   * @returns {string} Returns a link-friendly string.
   */
  public static getLinkFriendlyString(str: string): string {
    return str
      .replace(/ä/g, 'ae')
      .replace(/ü/g, 'ue')
      .replace(/ö/g, 'oe')
      .replace(/\W+/g, '-');
  }

  /**
   * Generates an SEO-friendly product detail URL.
   * @param productName The product's name
   * @param productSku The product's sku
   * @returns {string} Returns an SEO-friendly product detail URL
   */
  public static getProductDetailUrl(productName: string, productSku: string): string {
    return `${ConfigService.getProductDetailUrl()}/${productSku}/${this.getLinkFriendlyString(productName)}`;
  }

  /**
   * Gets an image URL for a product.
   * @param product The product to get an image URL for.
   * @returns {string} Returns an image URL.
   */
  public static getProductImageUrl(product: ProductDto): string {
    if (product.images.length === 0 || !product.images[0].thumbnailPath) {
      return '';
    }
    return `${ConfigService.getAssetBaseUrl()}/${product.images[0].thumbnailPath}`;
  }
}
